<div class="signatureAndValidationModal">
  <p-dialog [(visible)]="displayComponent"
            [header]="'SIGNATURE.AND.VALIDATION_COMPONENT.MODAL_TITLE' | translate"
            [draggable]="false"
            [closable]="true"
            [resizable]="false"
            [modal]="true" [closeOnEscape]="false"
            (onHide)="closeModal()">
    <div class="grid">

      <!--Workflow space choice-->
      <div class="col-4 leftPart">
        <div class="col-12 center">
          <button pButton type="button" [label]="'COMMON.REFRESH' | translate" class="p-button-info"
                  (click)="updateWorkflows(true)"></button>
        </div>
        <div class="col-12 center">
          <app-action-and-space-choice (selectedSpaceName)="handleChangeOfSpace($event)"
                                       [listOfWorkflows]="listOfWorkflows"></app-action-and-space-choice>
        </div>

      </div>
      <!--End of Workflow space choice-->

      <!--List of folds and buttons-->
      <div class="rightPart">
        <!--Buttons-->
        <div class="center">
          <div class="col-4">
            <p-splitButton [disabled]="this.tickedFolds.length===0" [styleClass]="'p-button-success'"
                           [label]="'SIGNATURE.AND.VALIDATION_COMPONENT.ACCEPT_BUTTON_LABEL' | translate"
                           icon="fa fa-check" (onClick)="acceptFolds()" [model]="acceptItems"></p-splitButton>
          </div>
          <div class="col-4">
            <button pButton type="button" [icon]="'fa fa-step-forward'" class="p-button-warning"
                    [disabled]="this.tickedFolds.length===0"
                    [label]="'SIGNATURE.AND.VALIDATION_COMPONENT.REWORK_BUTTON_LABEL' | translate"
                    (click)="retryFolds()">
            </button>
          </div>
          <div class="col-4">
            <p-splitButton [disabled]="this.tickedFolds.length===0" [styleClass]="'p-button-danger'"
                           [label]="'SIGNATURE.AND.VALIDATION_COMPONENT.DECLINE_BUTTON_LABEL' | translate"
                           icon="fa fa-times" (onClick)="displayGround=true" [model]="refuseItems"></p-splitButton>
          </div>
        </div>
        <!--End of Buttons-->

        <!--List of folds-->
        <div class="col-12">
          <app-fold-workflow-list (tickedFolds)="setListOfTicketFolds($event)" (selectedFold)="setActiveFold($event)"
                                  [listOfFolds]="listOfFolds"></app-fold-workflow-list>
        </div>
        <!--End of List of folds-->


      </div>
      <!--End of list of folds and buttons-->

      <!--Fold details and actions-->
      <div *ngIf="activeFold" class="col-12 bottomPart">
        <app-fold-detail [fold]="activeFold"></app-fold-detail>
        <app-fold-action [fold]="activeFold"></app-fold-action>
      </div>

      <!--end of fold details and actions-->

    </div>

    <!--Refusal motives-->
    <app-ground [(display)]="displayGround" (reason)="handleRefusal($event)"></app-ground>
    <!--Noitfy mail list-->
    <app-notify [(display)]="displayAcceptNotify" (acceptEventEmitter)="acceptFoldsAndNotify($event)" [showRejectReason]="false"></app-notify>
    <app-notify [(display)]="displayRefuseNotify" (rejectEventEmitter)="rejectFoldsAndNotify($event)" [showRejectReason]="true"></app-notify>

  </p-dialog>
</div>
